
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class DigitalSignalEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const lines = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1.5 * scale;

        const draw = () => {
            for (let i = 0; i < lines; i++) {
                const y = (height / lines) * (i - lines / 2) * 2;
                ctx.save();
                ctx.globalAlpha *= 0.4 / layerIndex;
                ctx.beginPath();
                const step = 40 * scale;
                for (let x = -width * 2; x <= width * 2; x += step) {
                    const high = this.pseudoRandom(x + i + Math.floor(curTime)) > 0.5;
                    const h = high ? -20 * scale : 20 * scale;
                    if (x === -width * 2) ctx.moveTo(x, y + h);
                    else {
                        ctx.lineTo(x, y + h);
                        ctx.lineTo(x, y - h);
                    }
                }
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
